var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPantry = function SvgPantry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M11.638 6.205h6.278v2.898h-6.278z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.916 3.79h-1.45c-1.212 0-2.414.65-2.414 1.45s1.154 1.448 2.415 1.448h1.449a1.449 1.449 0 0 0 0-2.897"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.018 5.24c0-.8.649-1.45 1.449-1.45h-4.83v2.898h4.83c-.8 0-1.449-.648-1.449-1.449"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M17.902 8.62c-1.435 0-2.401.653-2.401 1.448l.966 5.775h2.87v-5.775c0-.795-.641-1.448-1.435-1.448"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M17.902 8.62h-6.264v7.223h4.829v-5.775c0-.795.641-1.44 1.435-1.448"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M13.259 6.36a3 3 0 0 1-.541-.647c-1.998 0-3.338 2.183-3.338 3.872l.966 4.347h4.346V9.585c0-1.28-.553-2.43-1.433-3.225"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M12.718 5.713a2.9 2.9 0 0 1-.44-1.521V.966H8.414v3.226c0 .83-.364 1.612-.98 2.168A4.33 4.33 0 0 0 6 9.586v4.346h4.346V9.586c0-1.69.964-3.154 2.372-3.873"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.775 7.703S9.38 8.91 9.38 9.586l.966 4.346h1.932V9.586c0-.92-.643-1.688-1.504-1.883"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.775 7.702a1.932 1.932 0 0 0-2.36 1.883v4.347h1.931V9.586c0-.675.154-1.314.429-1.884"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.036 0h-1.448C9.57 0 8.656.432 8.656.966c0 .533.963.966 1.931.966h1.45a.966.966 0 0 0 0-1.932"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.622.966c0-.534.432-.966.966-.966H8.656a.966.966 0 0 0 0 1.932h1.931a.966.966 0 0 1-.965-.966"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M3.79 24h9.659L12 12 1.86 14.897v7.171c0 1.067.864 1.932 1.93 1.932"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M5.24 22.068v-8.136l-3.38.965v7.171c0 1.067.864 1.932 1.93 1.932h3.381a1.93 1.93 0 0 1-1.932-1.932"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.449 24h6.76a1.93 1.93 0 0 0 1.932-1.932v-7.17L12 12v10.551c0 .8.649 1.449 1.449 1.449M5.554 12c-1.039 0-1.555.2-1.653.495l-1.449 4.346c-.156.47.395.954 1.653.954h5.441c.312 0 .589-.2.688-.496L12 12z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m3.418 16.841 1.449-4.346A.72.72 0 0 1 5.554 12h-3.38c-.312 0-.589.2-.688.495L.038 16.841a.724.724 0 0 0 .687.954h3.38a.724.724 0 0 1-.687-.954"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "m23.962 16.841-1.448-4.346a.72.72 0 0 0-.688-.495H15.38l.801 5.3c.099.295.834.495 1.653.495h5.441a.724.724 0 0 0 .687-.954"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M17.147 17.3 15.38 12H12l1.767 5.3a.72.72 0 0 0 .687.495h3.38a.72.72 0 0 1-.687-.496"
  })));
};
export default SvgPantry;